import LoginForm from "./form.login";
import Logo from "../../../components/Logo";

import loginPageBanner from "../../../assets/login-banner-new.png";
import { Col, Row, Typography } from "antd";

const { Title, Text } = Typography;

const Login = () => {
  return (
    <div style={{ padding: "20px", minHeight: "100vh", background: "#fff" }}>
      <Row align="middle" gutter={30} style={{ minHeight: "calc(100vh - 40px)" }}>
        <Col xs={0} sm={0} md={0} lg={0} xl={12}>
          <div
            style={{
              position: "relative",
              borderRadius: "24px",
              overflow: "hidden",
              height: "calc(100vh - 40px)",
            }}
          >
            <img
              src={loginPageBanner}
              alt="Login Banner"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                textAlign: "center",
                padding: "clamp(32px, 5vw, 60px) clamp(24px, 4vw, 48px)",
              }}
            >
              <h2
                style={{
                  color: "#ffffff",
                  fontSize: "clamp(22px, 2.5vw, 34px)",
                  fontWeight: 700,
                  margin: 0,
                  lineHeight: 1.3,
                }}
              >
                Organise remarkable
                <br />
                events with ease.
              </h2>
            </div>
          </div>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={12}>
          <div
            style={{
              maxWidth: "420px",
              margin: "0 auto",
              padding: "40px 20px",
            }}
          >
            <div style={{ textAlign: "center", marginBottom: "32px" }}>
              <div style={{ display: "flex", justifyContent: "center", marginBottom: "24px" }}>
                <Logo />
              </div>
              <Title level={3} style={{ margin: 0 }}>
                Log in to your account
              </Title>
              <Text type="secondary">
                Welcome back! Please enter your details.
              </Text>
            </div>

            <LoginForm />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Login;
